export default ({ sendTypingIndicator }) => sendTypingIndicator;
